module.exports = __webpack_public_path__ + "static/img/10.6ddecca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/eng/10.png
// module id = UQdL
// module chunks = 0